// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__qJlZ4","title":"Images90_title__1GAOD","images":"Images90_images__29aji"};